'use strict';

import RadialSlider from "../../RadialSlider";

const elSliderOne = document.getElementById('slider-1');

new RadialSlider(elSliderOne, {
	radius: 2400,
	itemAngle: 10,
});
